module.exports = __webpack_public_path__ + "static/media/calendar.9c961993.svg";